var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      attrs: {
        action: _vm.filesUploadApi + "?name=test",
        "list-type": "picture-card",
        multiple: "",
        disabled: _vm.disabled,
        headers: _vm.headers,
        "file-list": _vm.fileList,
        "on-success": _vm.handleSuccess,
        "on-error": _vm.handleError,
        "on-remove": _vm.handleRemove,
        "auto-upload": true,
        "before-upload": _vm.handleBeforeUpload,
      },
      scopedSlots: _vm._u([
        {
          key: "file",
          fn: function (ref) {
            var file = ref.file
            return _c(
              "div",
              {
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.downloadFile(file)
                  },
                },
              },
              [
                file.status === "success"
                  ? [
                      _vm.isImage(file.name)
                        ? [
                            _c("img", {
                              staticClass: "el-upload-list__item-thumbnail",
                              attrs: { src: file.url, alt: "" },
                            }),
                          ]
                        : [
                            _c(
                              "div",
                              {
                                staticClass: "el-upload-list__item-thumbnail",
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "center",
                                  "background-color": "#f5f7fa",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-document",
                                  staticStyle: {
                                    "font-size": "24px",
                                    color: "#909399",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "text-align": "left",
                                      "word-break": "break-all",
                                      "max-width": "80px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(file.name) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                    ]
                  : file.status === "fail"
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "el-upload-list__item-thumbnail upload-processing",
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              "font-size": "24px",
                              color: "#f56c6c",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-status-text" }, [
                            _vm._v("上传失败"),
                          ]),
                        ]
                      ),
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticClass:
                            "el-upload-list__item-thumbnail upload-processing",
                        },
                        [
                          _c("el-progress", {
                            attrs: {
                              type: "circle",
                              percentage: _vm.uploadPercent(file),
                              width: 64,
                              "stroke-width": 5,
                              "show-text": false,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "upload-status-text upload-status-text--percent",
                            },
                            [
                              _vm._v(
                                "上传中 " +
                                  _vm._s(_vm.uploadPercent(file)) +
                                  "%"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                _vm._v(" "),
                !_vm.disabled
                  ? _c(
                      "span",
                      {
                        staticClass: "el-upload-list__item-delete",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleRemove(file)
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-delete" })]
                    )
                  : _vm._e(),
              ],
              2
            )
          },
        },
      ]),
    },
    [
      !_vm.disabled
        ? _c("i", {
            staticClass: "el-icon-plus",
            attrs: { slot: "default" },
            slot: "default",
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }